import { createFileRoute } from "@tanstack/react-router";
import { useCallback } from "react";
import { countListQuery } from "@/features/counts/api";
import { CountsPage } from "@/features/counts/CountsPage";
import { validateCountsSearch, type CountsSearch } from "@/features/counts/search";
import { warehouseListQuery } from "@/features/warehousing/api";
import { stockCountListColumns } from "@patronix/domain/list";
import { viewQuery } from "@/lib/listView";

// Cycle counts: list (keyset on created_at, id; status filter) → count panel
// (stock_count_document + keyset line pages) with start / enter / post / cancel.

export const Route = createFileRoute("/_app/warehousing/cycle-counts")({
  validateSearch: validateCountsSearch,
  loaderDeps: ({ search }) => ({ status: search.status, f: search.f, s: search.s }),
  loader: ({ context, deps }) => {
    void context.queryClient.prefetchInfiniteQuery(warehouseListQuery(false));
    return context.queryClient.ensureInfiniteQueryData(countListQuery(deps.status, viewQuery(stockCountListColumns, deps)));
  },
  component: CycleCountsRoute,
});

function CycleCountsRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const setSearch = useCallback(
    (patch: Partial<CountsSearch>) => void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true }),
    [navigate],
  );
  return <CountsPage search={search} setSearch={setSearch} />;
}
